import { Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@shared/components';

const { Text } = Typography;

interface Props {
  btnText?: string;
  content: React.ReactNode | string;
  errorCode?: string;
  hideTitle?: boolean;
  onClose: () => void;
  showContactInfo?: boolean;
  title?: React.ReactNode | string;
}

const ErrorModal = ({ btnText = 'Ok', content, errorCode, hideTitle, onClose, showContactInfo, title }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col text-center">
      {!hideTitle && <Text className="mb-2 text-base font-bold">{title || 'Request Unsuccessful'}</Text>}
      <div className="mb-4 text-sm">
        {content}
        {!!showContactInfo && (
          <Typography.Text>
            {t('emptyState.help')}{' '}
            <Typography.Link className="text-theme-600" href="tel:18002254482">
              1800 225 4482
            </Typography.Link>{' '}
            or{' '}
            <Typography.Link className="text-theme-600" href="mailto:contact_us@healthhub.sg">
              contact_us@healthhub.sg
            </Typography.Link>
          </Typography.Text>
        )}
      </div>
      {!!errorCode && <Text className="text-sm mb-2 inline-block text-theme-700">(Code: {errorCode})</Text>}
      <div className="flex justify-center">
        <Button className="json-checked mb-2 w-full" htmlType="submit" onClick={onClose}>
          {btnText}
        </Button>
      </div>
    </div>
  );
};

export default ErrorModal;
